export default __webpack_public_path__ + "static/media/uploadicon.e372b63a.svg";